<style>
  /* Custom Scrollbar for WebKit browsers */
  .custom-scrollbar::-webkit-scrollbar {
    width: 10px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 5px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: #007BFF;
    border-radius: 5px;
    opacity: 0.5;
    transition: background-color 0.3s, opacity 0.3s;
  }

  .custom-scrollbar:hover::-webkit-scrollbar-thumb {
    background-color: #0056b3;
    opacity: 1;
  }

  /* Custom Scrollbar for Firefox */
  .custom-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: #007BFF transparent;
  }

  .custom-scrollbar:hover {
    scrollbar-color: #0056b3 transparent;
  }
</style>

<script>
    // @ts-check
    import { navigate } from 'svelte-routing';
    import { idToken, isAdmin } from './stores/id_token';

    /**
     * @type {import('./types/category.d').Category[]}
     */
    export let categories;
    /**
     * @type {(a: string) => void}
     */
    export let onCategorySelected;

    let activeCategory = null;
  
    function toggleCategory(index) {
        if (activeCategory === index) {
            activeCategory = null;
            onCategorySelected(null);
        } else {
            activeCategory = index;
        }
    }
    function selectCategory(e, subcategory) {
        e.stopPropagation();
        onCategorySelected(subcategory);
    }
    const subcategorySizePx = 70;

    // Reactive statement for visible categories
    $: visibleCategories = categories.filter(category => {
        if (category.name === "Admin") {
            return $isAdmin;
        }
        return true;
    });
</script>
<!-- Overlay  -->
<div class="relative">
    <div class="absolute top-0 left-0 right-0 h-screen bg-gradient-to-b from-blue-600 to-10% to-transparent pointer-events-none z-10"></div>
    <div class="absolute bottom-0 left-0 right-0 h-screen bg-gradient-to-t from-blue-600 to-10% to-transparent pointer-events-none z-10"></div>
    <div class="overscroll-contain relative overflow-auto h-[50vh] md:h-[62vh] pr-1 pl-1 custom-scrollbar">
        <ul class="py-5">
        {#each visibleCategories as category, index}
          <li class="bg-blue-700 my-1 p-2 rounded-lg text-white transition-all duration-300 ease-in-out transform hover:bg-blue-800" on:click={() => toggleCategory(index)}>
            <div class="p-1 cursor-pointer">{category.name}</div>
            <div class="transition-all duration-300 ease-in-out transform opacity-0" class:max-h-0={activeCategory != index} class:translate-y-[-100%]={activeCategory !== index} class:opacity-100={activeCategory === index} class:translate-y-0={activeCategory === index} style="max-height: {activeCategory === index ? `${category.subcategories.length * subcategorySizePx}px` : '0'}; overflow: hidden;">
              <ul class="mt-2">
                {#each category.subcategories as subcategory}
                  <li class="cursor-pointer ml-4 rounded-lg bg-blue-700 my-1 p-2 text-white" style="max-height: {subcategorySizePx}px;" on:click={(e) => selectCategory(e, subcategory)}>{subcategory}</li>
                {/each}
              </ul>
            </div>
          </li>
        {/each}
      </ul>    
    </div>
</div>
